import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { IOpportunityStage } from '~/types/opportunity/models'
import type { TEntityId } from '~/types/models'

const opportunityStageListData = undefined as unknown as IOpportunityStage[]

export const getOpportunityStageListData = getListDataFunctionFactory<
  IOpportunityStage[]
>({
  listData: opportunityStageListData,
  storageKey: 'opportunitystages',
  getStartingListData: getStartingOpportunityStageListData,
})

export async function getOpportunityStageDataById(
  id: TEntityId
): Promise<IOpportunityStage> {
  const list: IOpportunityStage[] = await getOpportunityStageListData()
  if (!list) {
    throw new Error(`getOpportunityStageListData returned undefined/null`)
  }
  const os = list.find((opportunityStage) => opportunityStage.id === id)
  if (!os) {
    throw new Error(`Can't find opportunityStage '${id}'`)
  }
  return os
}

export async function getOpportunityStageDataByDescr(
  descr: string
): Promise<IOpportunityStage> {
  const list: IOpportunityStage[] = await getOpportunityStageListData()
  if (!list) {
    throw new Error(`getOpportunityStageListData returned undefined/null`)
  }
  const os = list.find((opportunityStage) => opportunityStage.descr === descr)
  if (!os) {
    throw new Error(`Can't find opportunityStage '${descr}'`)
  }
  return os
}

export async function getStartingOpportunityStageListData(): Promise<
  IOpportunityStage[]
> {
  return [
    {
      id: 'XXOS0001',
      hrid: 'OS0001',
      descr: 'Lead',
      seqNum: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXOS0002',
      hrid: 'OS0002',
      descr: 'Qualification',
      seqNum: 2,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0003',
      hrid: 'OS0003',
      descr: 'Needs Analysis',
      seqNum: 3,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0004',
      hrid: 'OS0004',
      descr: 'Value Proposition',
      seqNum: 4,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0005',
      hrid: 'OS0005',
      descr: 'Id Decision Makers',
      seqNum: 5,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0006',
      hrid: 'OS0006',
      descr: 'Perception Analysis',
      seqNum: 6,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0007',
      hrid: 'OS0007',
      descr: 'RFQs Sent',
      seqNum: 17,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0008',
      hrid: 'OS0008',
      descr: 'Negotiation',
      seqNum: 8,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOS0009',
      hrid: 'OS0009',
      descr: 'Quotes Received',
      seqNum: 9,
      version: '1',
      canBeDeleted: true,
    },
  ]
}
